
import NotificationSystem from 'react-notification-system';
const NOTIFICATION_SYSTEM = (props ) => {
    return (
        <div style={{ width: "100%", margin: "0 auto" }} className="new_table_v2">
            <NotificationSystem ref={props.notificationSystemRef}></NotificationSystem>
        </div>
    );
};

export default NOTIFICATION_SYSTEM;
